import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  ArrowLeftIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';
import { EXECUTIVES } from '../../data/executives';

const ExecutiveDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const executive = EXECUTIVES.find(e => e.id === id);

  if (!executive) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Executive Not Found</h2>
          <Link to="/about/executives" className="btn-primary">
            <ArrowLeftIcon className="w-5 h-5 mr-2 inline" />
            Back to Executives
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with Executive Info */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="section-padding pb-0">
          <Link 
            to="/about/executives"
            className="inline-flex items-center text-gray-600 hover:text-primary-600 mb-6"
          >
            <ArrowLeftIcon className="w-5 h-5 mr-2" />
            Back to Executives
          </Link>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Executive Photo */}
            <div className="lg:col-span-1">
              <div className="relative w-full">
                <img
                  src={executive.image}
                  alt={executive.name}
                  className="w-full h-auto rounded-xl shadow-lg"
                  onError={(e) => {
                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${executive.name}&size=800&background=1e40af&color=fff`;
                  }}
                />
              </div>
            </div>

            {/* Executive Basic Info */}
            <div className="lg:col-span-2">
              <div className="flex items-center mb-4">
                <ShieldCheckIcon className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-primary-600 font-semibold">{executive.position}</h2>
              </div>
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                {executive.name}
              </h1>
              <div className="text-lg text-gray-600 leading-relaxed mb-6 space-y-4">
                {Array.isArray(executive.bio) ? (
                  executive.bio.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))
                ) : (
                  <p>{executive.bio}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveDetailPage;